import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { providePboCustomIcons } from '@bo-ui/pinata/icon';
import { providePboTheme } from '@bo-ui/pinata/themes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';

import { appInit } from './app-init.function';
import { appRoutes } from './app.routes';
import { environment } from './environments/environment';
import { AUTH_HTTP_INTERCEPTORS } from './interceptors/auth';
import { ORGANIZATION_HTTP_INTERCEPTORS } from './interceptors/organization';
import { OrganizationRouteReuseStrategy } from './routing/organization-route-reuse.strategy';
import { WINDOW } from './shared/common';
import { TranslateLoaderService } from './shared/services/translate-loader.service';

const loggerLevel = environment.production
  ? NgxLoggerLevel.WARN
  : NgxLoggerLevel.DEBUG;

const loggerModule = LoggerModule.forRoot({
  level: loggerLevel,
  serverLogLevel: NgxLoggerLevel.OFF,
});

const translateModule = TranslateModule.forRoot({
  fallbackLang: 'en',
  loader: {
    provide: TranslateLoader,
    useClass: TranslateLoaderService,
    deps: [HttpClient],
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(appInit),
    importProvidersFrom(
      loggerModule,
      translateModule,
    ),
    providePboCustomIcons('icons'),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([
        ...AUTH_HTTP_INTERCEPTORS,
        ...ORGANIZATION_HTTP_INTERCEPTORS,
      ]),
    ),
    providePboTheme(),
    provideRouter(appRoutes),
    {
      provide: RouteReuseStrategy,
      useExisting: OrganizationRouteReuseStrategy,
    },
    {
      provide: WINDOW,
      useValue: window,
    },
  ],
};
